<template>
  <div class="swipe-box">
    <van-swipe :autoplay="3000" indicator-color="white" class="my-swipe">
      <van-swipe-item v-for="(item, index) of bannerInfo" :key="index">
        <img :src="item.banner_pic" />
      </van-swipe-item>
    </van-swipe>
  </div>
</template>
<script>
import { Swipe, SwipeItem } from 'vant';

export default {
  props: ['bannerInfo'],
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem
  },
}
</script>
<style lang="scss" scoped>
$default-height: 2.42rem; // 默认高度
.swipe-box {
  height: $default-height;
  width: $cake-box-width;
  border-radius: 12px;
  margin: 0.3rem auto;
}
.my-swipe {
  border-radius: 12px;
}

.my-swipe .van-swipe-item {
  height: $default-height;
}
.van-swipe-item img {
  // object-fit: cover;
}
img {
  width: 100%;
  height: $default-height;
}
</style>